import './modules/polyfills';
import PageChecker from './modules/Page';
import Vue from 'vue';
import Global from './modules/Global';
import './modules/Modals';
import './modules/HeaderSearch';
import { loader as loadPlugins } from './plugins';
import { loader as loadComponents } from './components';
import { loader as loadDirectives } from './directives';
import { loader as loadFilters } from './filters';
import { getViewData } from './modules/view-data';

/**
 * Setup global vars, bound to window
 */
global.Global = Global;
global.Template = new PageChecker({ type: 'template' });
global.Page = new PageChecker({ type: 'page' });

// Run the loaders to set up the globals
loadPlugins();
loadComponents();
loadDirectives();
loadFilters();

require('./bootstrap');

/**
 * Specific page loader
 * This allows us to lazy load page-specific functionality
 */
let LoadedPage = Promise.resolve();

if (
    window.location.pathname.indexOf('account') > -1
    || window.location.host.startsWith('account.')
) {
    LoadedPage = require('./account').default;
} else if (
    window.location.pathname.includes('/list-your-space') // Actual path
    || window.location.host.startsWith('listing.') // Subdomain proxy for prod/pre-prod
) {
    LoadedPage = require('./listing').default;
} else if (getViewData('whitelabel')) {
    LoadedPage = require('./whitelabel').default;
} else {
    LoadedPage = require('./frontend').default;
}

Promise.all(LoadedPage)
    .then((pages) => pages.map(({ default: Page }) => new Page))
    .then((response) => {
        // If the page we're loading is an SPA we'll let it
        // handle it's own vue instance setup
        if (!response.find(({ hasRouter }) => hasRouter)) {
            new Vue(require('./app-base').default);
        }
    });
